// @ts-nocheck
import { Button } from 'react-bootstrap'
import { useDispatch } from 'react-redux';
import {
    setPayloadSliderFalse,
} from '../../../../../store/MissionSlice';
import CustomToolTip from '../../../../CommonComponents/CustomToolTip';
const PayloadSlider = ({ payloadSliderData }) => {

    const dispatch = useDispatch();

    const atmosData = payloadSliderData?.atmosData ? payloadSliderData?.atmosData : payloadSliderData?.["atmos-data"]
    const userData = payloadSliderData?.userData ? payloadSliderData?.userData : payloadSliderData?.["user_data"]

    const formatParams = (params: Record<string, any>, labelClass = "temp-label") => {
        return Object.entries(params || {}).map(([k, v]) => {
            if (k === 'Data Rate') v = `${v} Mbps`;
            if (k === "GSD") v = `${v} m`;
            if (k === "Swath") v = `${v} km`;
            if (k === "Frequency Bands" && Array.isArray(v)) {
                v = v.map((band: string, idx: number) => (
                    <span key={idx} className="d-flex">
                        {band} {idx !== v.length - 1 && "|"}
                    </span>
                ));
            }
            return (
                <div key={k} className="d-flex flex-wrap">
                    <span className={labelClass}>
                        <CustomToolTip title={k} maxWidth="300px" placement="top-start">
                            {k}
                        </CustomToolTip>
                    </span>
                    <div className="d-flex align-items-center w-60">
                        <span className="w-100 text-truncate">
                            <CustomToolTip title={v} maxWidth="300px" placement="top-start">
                                : {v}
                            </CustomToolTip>
                        </span>
                    </div>
                </div>
            );
        });
    }

    return (
        <div className="right-slider-box">
            <div className="slider-header">
                <h4>HW Device Details</h4>
            </div>
            <div className="slider-content">
                {/*<div className="common-card-box w-100" style={{display:'flex', position:"absolute", top: 100,}}>*/}
                <div className="common-card-box w-100">
                    <div className="common-card-header flex-column d-flex align-items-baseline">
                        {userData?.['payload_name']}
                    </div>
                    <div className="common-card-footer" style={{ color: 'rgba(255,255,255,0.7)' }}>
                        <div className="d-flex flex-column">
                            <div className="d-flex"><span className="temp-label">Category </span>: {atmosData?.['component_specific_attributes']['payloadType']}</div>
                            {atmosData?.['component_specific_attributes']['payloadSubType'] !== '' && <div className="d-flex"><span className="temp-label">Payload Type </span>: {atmosData?.['component_specific_attributes']['payloadSubType']}</div>}
                            {atmosData?.['component_specific_attributes']['payloadDetails'] !== '' && <div className="d-flex"><span className="temp-label"> Payload SubType </span>: {atmosData?.['component_specific_attributes']['payloadDetails']}</div>}
                            <div className="d-flex"><span className="temp-label">Size </span>: {atmosData?.['product-cookie']['Size'] + ' U'}</div>
                            <div className="d-flex"><span className="temp-label">Mass </span>: {(atmosData?.['weight_in_gms'] > 999) ?
                                ((atmosData?.['weight_in_gms'] / 1000) + ' kg')
                                : (atmosData?.['weight_in_gms'] + ' g')}</div>
                            <div className="d-flex"><span className="temp-label">Peak Power </span>: {atmosData?.['max_power_consumption_in_watts'] + ' W'}</div>


                            {atmosData?.['product-cookie']?.['Coding Scheme'] && <div className="d-flex"><span className="temp-label">Coding Scheme </span>: {atmosData?.['product-cookie']?.['Coding Scheme']}</div>}
                            {atmosData?.['product-cookie']?.['Gain'] && <div className="d-flex"><span className="temp-label">Gain </span>: {atmosData?.['product-cookie']?.['Gain']}</div>}
                            {atmosData?.['product-cookie']?.['Modulation'] && <div className="d-flex"><span className="temp-label">Modulation </span>: {atmosData?.['product-cookie']?.['Modulation']}</div>}
                            {atmosData?.['product-cookie']?.['Polarization'] && <div className="d-flex"><span className="temp-label">Polarization </span>: {atmosData?.['product-cookie']?.['Polarization']}</div>}
                            {atmosData?.['product-cookie']?.['Tx channels'] && <div className="d-flex"><span className="temp-label">TX Channel </span>: {atmosData?.['product-cookie']?.['Tx channels']}</div>}
                            {atmosData?.['average_power_consumption'] && <div className="d-flex"><span className="temp-label">Average Power</span>: {atmosData?.['average_power_consumption'] + ' W'}</div>}

                            {atmosData?.['product-cookie']?.['Supported Interface'] && <div className="d-flex"><span className="temp-label">Suported Interfaces </span>: {atmosData?.['product-cookie']?.['Supported Interface']}</div>}
                        </div>
                        <div className="d-flex flex-column">
                            {formatParams(atmosData?.['component_specific_attributes']?.typeSpecificParams)}
                        </div>

                        {/*  Additional Params */}
                        <div className="d-flex flex-column">
                            {formatParams(atmosData?.['component_specific_attributes']?.additionalParams)}
                        </div>
                        <div className='d-flex'><span className="temp-label">Interface </span>: <span className='d-flex flex-wrap ms-1'>
                            {atmosData?.['component_specific_attributes']?.['interfaces'].map((item, i) => (
                                <span className={`d-flex ${i !== 0 ? 'ps-1' : ''}`} key={i}>{item} {atmosData?.['component_specific_attributes']?.['interfaces']?.length !== i + 1 && ' | '}</span>
                            ))}</span>
                        </div>
                    </div>
                </div>

                {/* Antenna details */}
                {(userData?.['payload_name'] === 'IQ Spacecom XLink-S' && atmosData?.['antenna'] && typeof atmosData?.['antenna'] === 'object') && <div className="common-card-box w-100">
                    <div className="common-card-header flex-column d-flex align-items-baseline">
                        {atmosData?.antenna?.['friendly-name']}
                    </div>
                    <div className="common-card-footer" style={{ color: 'rgba(255,255,255,0.7)' }}>
                        <div>
                            {Object.keys(atmosData?.antenna || {})
                                .filter(key => key !== "friendly-name")
                                .map((k, i) => (
                                    <span key={i} className="d-flex gap-1">
                                        <span className="temp-label">{k}</span> : {atmosData?.antenna[k]}
                                    </span>
                                ))
                            }
                        </div>

                    </div>
                </div>}
            </div>
            <div className='slider-footer'>
                <Button
                    variant="primary"
                    type="button"
                    className="btn btn-primary pt-1 pb-1 pe-6 ps-6 me-3 fs-14"
                    onClick={() => {
                        dispatch(setPayloadSliderFalse())
                    }}
                >
                    Close
                </Button>
            </div>
        </div>
    )
}

export default PayloadSlider
